import React, { FC } from "react";
import { Button } from "../../components";
import { useTranslation } from "react-i18next";
import { AppConfig } from "../../config";
import stl from "./index.module.scss";
import errorImg from "../../assets/images/Error-person.svg";

const Timeout: FC = () => {
  const { t } = useTranslation(AppConfig.translationFileNames.base);

  const retry = () => {
    window.location.reload();
  };

  return (
    <div style={{ textAlign: "center" }}>
      <img className={stl.img} src={errorImg} alt={""} />
      <h1 className={stl.title}>{t("sessionExpired.title")}</h1>
      <p className={stl.subtitle}>{t("sessionExpired.subtitle")}</p>
      <p className={stl.subsubtitle}>{t("sessionExpired.subsubtitle")}</p>
      <Button variant={"primary"} onClick={retry} className={stl.button}>
        {t("sessionExpired.button")}
      </Button>
    </div>
  );
};

export default Timeout;
